export default __webpack_public_path__ + "static/media/Green Visa - Overview.115a4726.jpg";